import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import { useRillContext } from "../../rill/RillReact/share/base";
import ProductTabs from "./ProductTabs";

const getFilters = (t) => [
  {
    actionTypes: [
      {
        title: () => t("filterOptions.onboarding"),
        value: "finished-onboarding",
      },
      { title: () => t("filterOptions.progressPhotos"), value: "bodyPhotos" },
      { title: () => t("filterOptions.bodyweight"), value: "bodyWeight" },
      {
        title: () => t("filterOptions.bodyMeasurements"),
        value: "bodyMeasurements",
      },
      { title: () => t("filterOptions.nutrition"), value: "nutrients" },
      { title: () => t("filterOptions.dailySteps"), value: "steps" },
      {
        title: () => t("filterOptions.bodyFatPercentage"),
        value: "bodyFatPercentage",
      },
      {
        title: () => t("filterOptions.restingHeartRate"),
        value: "restingHeartRate",
      },
    ],
  },
  {
    actionTypes: [
      { title: () => t("filterOptions.dailySleep"), value: "sleep" },
      { title: () => t("filterOptions.hrv"), value: "hrv" },
      { title: () => t("filterOptions.readinessRate"), value: "readiness" },
      {
        title: () => t("filterOptions.dailyAccountabilities"),
        value: "completed-accountabilities",
      },
      { title: () => t("filterOptions.checkIns"), value: "completed-check-in" },
      {
        title: () => t("filterOptions.completedWorkouts"),
        value: "swipe-completed-workout",
      },
      {
        title: () => t("filterOptions.onboardingQuestionnaire"),
        value: "completed-onboarding-check-in",
      },
    ],
  },
  {
    actionTypes: [
      { title: () => t("filterOptions.sessionRPE"), value: "sessionRPE" },
      {
        title: () => t("filterOptions.uploadedVideos"),
        value: "uploaded-video-set",
      },
      { title: () => t("filterOptions.setComment"), value: "commented-set" },
      {
        title: () => t("filterOptions.workoutComment"),
        value: "commented-workout",
      },
      {
        title: () => t("filterOptions.checkInComment"),
        value: "commented-check-in",
      },
      {
        title: () => t("filterOptions.checkInReview"),
        value: "watched-check-in-video",
      },
    ],
  },
  {
    actionTypes: [
      { title: () => t("filterOptions.addExercises"), value: "added-exercise" },
      {
        title: () => t("filterOptions.removeExercise"),
        value: "deleted-exercise",
      },
      {
        title: () => t("filterOptions.addProgram"),
        value: "added-calendar-program",
      },
      { title: () => t("filterOptions.moveWorkout"), value: "moved-workout" },
      { title: () => t("filterOptions.mealPhotos"), value: "meal-photos" },
    ],
  },
];
const ActivityFiltersModal = ({ openModal, closeModal, productTypes }) => {
  if (!openModal) return null;
  const { t } = useTranslation("activity");
  const { locals } = useRillContext();
  const referAsClients = locals.activeUser.referAsClients;
  const {
    query: { actionTypes, productType },
  } = locals;

  const filters = getFilters(t);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const selectType = (e) => {
    if (e.target.checked) {
      setSelectedFilters([...selectedFilters, e.target.value]);
    } else {
      setSelectedFilters(
        selectedFilters.filter((selectedF) => selectedF !== e.target.value)
      );
    }
  };
  useEffect(() => {
    if (actionTypes) setSelectedFilters(JSON.parse(actionTypes));
  }, []);
  const submitFilters = () => {
    if (selectedFilters.length > 0 && selectedFilters[0].length !== 0) {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          actionTypes: JSON.stringify(selectedFilters),
          page: 0,
        },
      });
    } else {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          "modal[type]": "activity-feed",
          actionTypes: "",
        },
      });
    }
    closeModal();
  };
  const closeHref = "/actions/refresh?modal[type]=activity-feed";

  return (
    <div role="modal" className="Modal-Box activity-filters-modal">
      <a href={closeHref} onClick={closeModal} className="overlay" />
      <div className="box">
        <header>
          <h2>{t("filtersModal.title")}</h2>
          <button
            onClick={closeModal}
            role="button"
            data-button-type="tertiary"
            data-icon-only="true"
          >
            <img src="/img/new-icons/red-cross.svg" alt="dismiss" />
          </button>
        </header>
        <div className="body">
          <header>
            <div className="unit-container">
              <ProductTabs
                locals={locals}
                productType={productType}
                isButton={true}
              />
            </div>
          </header>
          <div className="content">
            {filters.map((filter) => (
              <section>
                {filter.actionTypes.map((actionType) => (
                  <div>
                    <input
                      type="checkbox"
                      value={actionType.value}
                      name={actionType.value}
                      onClick={selectType}
                      checked={
                        selectedFilters.includes(actionType.value)
                          ? true
                          : undefined
                      }
                    />
                    <label htmlFor={actionType.value}>
                      {actionType.title(referAsClients)}
                    </label>
                  </div>
                ))}
              </section>
            ))}
          </div>
        </div>
        <footer>
          <button
            data-button-type="secondary"
            data-action="cancel"
            onClick={() => setSelectedFilters([])}
          >
            {t("filtersModal.clearAll")}
          </button>
          <button data-button-type="primary" onClick={submitFilters}>
            {t("filtersModal.filter")}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ActivityFiltersModal;
